import moment from 'moment';
import 'moment/locale/uk';
import dayjs from 'dayjs';
import 'dayjs/locale/uk';
import pluralizationRules from './pluralization-rules/eastern-slavic';
import setLocale from './i18n-config';
import i18nLocaleJsonData from './generated/uk.json';
import 'jquery'; // eslint-disable-line no-restricted-imports
import 'vendor/select2/select2'; // eslint-disable-line no-restricted-imports
import 'vendor/select2/select2_locale_uk';

const locale = 'uk';
setLocale(locale, i18nLocaleJsonData, pluralizationRules);
moment.locale(locale);
dayjs.locale(locale);
